import styled from 'styled-components';

export const GoogleMapsElement = styled.div<{ width: string; height: string }>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;
